import { compose, withHandlers, withProps, withState } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { formatPattern } from "react-router-utils";
import { getCart } from "app/redux/selectors";
import { getCartSaleId } from "app/redux/modules/cart";
import { withRouter } from "react-router-dom";
import { withTranslator } from "app/decorators";
import AccountConfirm from "./AccountConfirm";
import Immutable from "immutable";
import clearCart from "app/redux/actions/clearCart";
import doPayment from "app/redux/actions/doPayment";

const mapStateToProps = state => ({
  saleId: getCartSaleId(getCart(state))
});

const onConfirmPayment = ({ history, contact, doPayment, saleId, setIsPreparePayment, clubId, clearCart }) => () => {
  setIsPreparePayment(true);
  doPayment(contact.get("contactId"), saleId).then(paymentTransaction =>
    clearCart().then(() => {
      history.push(
        formatPattern(`/:clubId/checkout_process?transaction=${paymentTransaction.get("@id")}`, { clubId: clubId })
      );
    })
  );
};

export default compose(
  withRouter,
  withProps(({ match }) => ({
    clubId: decodeParam(match.params.clubId)
  })),
  connect(null, { doPayment, clearCart }),
  withState("isPreparePayment", "setIsPreparePayment", false),
  withState("cryptedContact", "setCryptedContact", Immutable.Map()),
  connect(mapStateToProps),
  withHandlers({ onConfirmPayment }),
  withTranslator
)(AccountConfirm);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/AccountConfirm/AccountConfirmContainer.js